(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-wager/assets/javascripts/generate-wager.js') >= 0) return;  svs.modules.push('/components/numbergames/game-wager/assets/javascripts/generate-wager.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _svs$numbergames = svs.numbergames,
  productMapping = _svs$numbergames.productMapping,
  getRules = _svs$numbergames.rules.getRules,
  gameWager = _svs$numbergames.gameWager;

function getWagerOptionsHandler(rules) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const getProducts = () => {
    var _ref, _options$product;
    const product = (_ref = (_options$product = options.product) !== null && _options$product !== void 0 ? _options$product : rules.productId) !== null && _ref !== void 0 ? _ref : '';
    if (!Array.isArray(options === null || options === void 0 ? void 0 : options.products)) {
      return productMapping.getAllItsIds(product);
    }
    return Array.from(new Set(options.products.flatMap(productMapping.getAllItsIds).filter(itsId => productMapping.getAllItsIds(product).includes(itsId))));
  };
  const getHasLotto2 = () => {
    var _options$hasLotto;
    return rules.hasLotto2 ? Boolean((_options$hasLotto = options.hasLotto2) !== null && _options$hasLotto !== void 0 ? _options$hasLotto : rules.hasLotto2) : undefined;
  };
  const getIsSubscription = () => Boolean(rules.hasSubscription) && Boolean(options.isSubscription);
  const getDrawCount = () => {
    const drawCount = options.drawCount;
    if (drawCount < 1 || !Number.isInteger(drawCount) || getIsSubscription()) {
      return 1;
    }
    return drawCount;
  };
  return {
    getProducts,
    getHasLotto2,
    getIsSubscription,
    getDrawCount
  };
}

function generateWager(options) {
  var _options;
  if (!((_options = options) !== null && _options !== void 0 && _options.product) && ['number', 'string'].includes(typeof options)) {
    options = {
      product: options
    };
  }
  const productId = productMapping.getProductId(options.product);
  const rules = getRules(productId, options.ruleOptions);
  if (!rules) {
    gameWager.logger.warn("Can not generate wager. Could not find rules for ".concat(options.product));
    return;
  }
  const wagerOptionsHandler = gameWager.getWagerOptionsHandler(rules, options);
  const boardOptions = _objectSpread(_objectSpread({}, options.boardOptions), {}, {
    ruleOptions: options.ruleOptions
  });
  const jokerOptions = options.jokerOptions === false ? options.jokerOptions : _objectSpread(_objectSpread({}, options.jokerOptions), {}, {
    ruleOptions: options.ruleOptions
  });
  return {
    productId,
    boards: gameWager.generateBoards(productId, boardOptions),
    joker: gameWager.generateJoker(productId, jokerOptions),
    products: wagerOptionsHandler.getProducts(),
    hasLotto2: wagerOptionsHandler.getHasLotto2(),
    drawCount: wagerOptionsHandler.getDrawCount(),
    isSubscription: wagerOptionsHandler.getIsSubscription()
  };
}
Object.assign(svs.numbergames.gameWager, {
  getWagerOptionsHandler,
  generateWager
});

 })(window);